import UI5Imports from './ui5-imports';
import Vue from 'vue';
import Vuelidate from 'vuelidate';
import store from './store';
import router from './router';
import UI5Styling from './ui5-styling';
import components from './components';
import UI5StylingMixin from './mixins/ui5-styling';
import UnsetUserLocationMixin from './mixins/unset-user-location-mixin';
import RouterViewMarginMixin from './mixins/router-view-margin';
import ScannerDetectionMixin from './mixins/scanner-detection';
import BottomScrollMixin from './mixins/bottom-scroll';
import WindowResizeMixin from './mixins/window-resize';
import LocalizationMixin from './mixins/localization';
import DefaultErrorsMixin from './mixins/default-errors';
import { checkIsTablet } from './helpers/StyleHelpers';
import api from './api/api';
import { PromiseOverride } from './promise-override';
import VueKonva from 'vue-konva';
import Tikklok from './shared/Tikklok';
import KeyHelperConstructor from './helpers/KeyHelper';
import moment from 'moment';
import 'moment/locale/nl-be';
import { registerLocaleDataLoader } from '@ui5/webcomponents-base/dist/asset-registries/LocaleData.js';
import vSelect from 'vue-select';
import localizationApi from './api/localization';
import layoutApi from './api/layout';

registerLocaleDataLoader('nl_BE', async () => {
    return new Promise(function (resolve, reject) {
        const xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function () {
            if (this.readyState == 4 && this.status == 200) {
                const json = JSON.parse(this.responseText);
                resolve(json);
            }
        };
        xhr.onerror = function () {
            reject(new TypeError('Local request failed'));
        };
        xhr.open('GET', `js/build/localization/ui5-nl_BE.json`);
        xhr.send();
    });
});

window.KeyHelper = KeyHelperConstructor(window.document);

window.Promise = PromiseOverride;

UI5Styling();

// Register interceptors
api.registerInterceptors();

const metaDataResponse = await layoutApi.fetchMetaData();

if (metaDataResponse.data.data) {
    document.title = metaDataResponse.data.data.title;
    store.commit('general/setAppTitle', metaDataResponse.data.data.title);
    store.commit(
        'general/setOperatorManager',
        metaDataResponse.data.data.operatorManager
    );
}

Vue.config.ignoredElements = [/^ui5-/];
Vue.use(Vuelidate);
Vue.use(VueKonva);

Vue.component('v-select', vSelect);

// Vue event bus
Vue.use({
    install(V) {
        let bus = new Vue();
        V.prototype.$bus = bus;
        V.bus = bus;
    },
});

// Load translations for saved locale or default
const savedLocale = localStorage.getItem('app_locale');
const translationsApiResponse = await localizationApi.translations(savedLocale);

if (!translationsApiResponse.data.data) {
    throw new Error('No translations found');
}

store.commit('localization/setTranslations', translationsApiResponse.data.data);

// Set current locale from localStorage or fetch default from API
if (savedLocale) {
    store.commit('localization/setCurrentLocale', savedLocale);
} else {
    const currentLocaleApiResponse = await localizationApi.currentLocale();
    if (!currentLocaleApiResponse.data.data) {
        throw new Error('No current locale found');
    }
    store.commit('localization/setCurrentLocale', currentLocaleApiResponse.data.data);
}

Vue.mixin(LocalizationMixin);
Vue.mixin(DefaultErrorsMixin);

window.newVueApp = new Vue({
    el: '#main-app',
    router,
    components,
    store,
    mixins: [
        UI5StylingMixin,
        UnsetUserLocationMixin,
        RouterViewMarginMixin,
        ScannerDetectionMixin,
        BottomScrollMixin,
        WindowResizeMixin,
    ],
    mounted() {
        moment.locale('nl-BE');

        if (this.$store.getters['currentUser/isValidLogin']) {
            Tikklok.initTikklok();
        }

        checkIsTablet();
    },
});
